import { styled } from '@/stitches.config';
import { ReactComponent as SpinnerIcon } from '@assets/icons/spinner.svg';
import { Box, SectionTitle } from '@common/components/base-app';

export const StyledContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
});

export const StyledSectionTitle = styled(SectionTitle, {
  fontWeight: '$bold',
});

export const StyledSpinnerIcon = styled(SpinnerIcon, {
  height: '$12',
  stroke: '$primary',
  marginTop: '$4',
  width: '$12',
});
